<template>
  <div>
    <LmListV2
      ref='LmWidgetsListbuilder'
      isGraphql
      :gqlField='gqlField'
      :gqlVariables='gqlVariables'
      :gqlQuery='gqlQuery'
      :searchOnFieldsSelected='searchOnFieldsSelected'
      :searchOnFieldsToSelected='searchOnFieldsToSelected'
      :items='items'
      :mode='mode'
      :allAvailableFields='fields'
      :listBuilderTitleList='listBuilderTitleList'
    />
  </div>
</template>

<script>
import LmListV2 from '@/components/LmListV2.vue'

export default {
  components: {
    LmListV2
  },
  data () {
    return {
      listBuilderTitleList: 'Listado de Widgets',
      gqlField: 'Widgets',
      gqlVariables: {
        q: 'deleted: false',
        sort: 'updatedAt__desc',
        page: 1
      },
      gqlQuery: `query($page:Int, $q:String, $sort:[WidgetsESSortEnum]) {
      Widgets(
          titleList: "Listado de Widgets"
          aggs: []
          q: $q
          perPage: 10
          page: $page
          sort: $sort
          metaSearch: "*"
          opts: {
            lenient: true
          }
          lmPathActions: [{to:"/widgets/editar/:_id",tooltip:"Editar",fontAwesomeIcon:"edit"}]
          lmModalActions: []
          buttonLinks: [{value:"Nuevo",to:"/widgets/nuevo",endpointToValidateVisibility:"",show:true,disabled:false,buttonClass:"btn-info"}]
          ) {
          count
          searcher
          tableItemsTotal
          titleList
          filter {
            aggregatesToSelect
          }
          table {
            items {
              name,createdAt,updatedAt,componentName,actions
            }
            fields {
              key
              label
              sortable
            }
          }
          buttons
          pagination
        }
      }`,
      searchOnFieldsSelected: ['name', 'component', 'createdAt', 'updatedAt', 'actions'],
      searchOnFieldsToSelected: ['name', 'createdAt', 'updatedAt', 'actions', 'componentName'],
      items: [
        {
          name: 'name',
          description: 'Nombre'
        },
        {
          name: 'component',
          description: 'Componente técnico'
        },
        {
          name: 'componentName',
          description: 'Componente'
        },
        {
          name: 'deleted',
          description: 'Borrado'
        },
        {
          name: 'createdAt',
          description: 'Creado'
        },
        {
          name: 'updatedAt',
          description: 'Actualizado'
        },
        {
          name: 'createdBy',
          description: 'Creado por'
        },
        {
          name: 'updatedBy',
          description: 'Actualizado por'
        },
        {
          name: 'actions',
          description: 'Acciones'
        }
      ],
      mode: {
        table: true,
        map: false
      },
      fields: [
        {
          key: 'name',
          label: 'Nombre',
          sortable: false
        },
        {
          key: 'componentName',
          label: 'Componente',
          sortable: false
        },
        {
          key: 'createdAt',
          label: 'Creado',
          sortable: true
        },
        {
          key: 'updatedAt',
          label: 'Actualizado',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Acciones',
          sortable: false
        }
      ]
    }
  }
}
</script>
